import React from "react";
import { useIntl } from "react-intl";
import { HeapPHIDecorator } from "@app/components/analytics";
import { messages } from "../messages";
import { Textfield } from "@natera/form";
import { GetValidationError } from "@natera/platform/lib/hooks/useError";
import { FormField } from "@app/components";

const ZipCodeField: React.FC<{
  getValidationError: GetValidationError;
  defaultValue?: string;
}> = ({ getValidationError, defaultValue }) => {
  const intl = useIntl();

  return (
    <>
      <div id="instructions" className="visually-hidden">
        {intl.formatMessage(messages.addressFormZipCodePlaceholder)}
        {intl.formatMessage(messages.addressFormZipTooltip)}
      </div>
      <FormField
        title={intl.formatMessage(messages.addressFormZipCode)}
        label={intl.formatMessage(messages.addressFormZipCode)}
        error={getValidationError("zipCode")}
        htmlFor="zipCode"
        required
        withPadding
      >
        <HeapPHIDecorator protectAttr={["value"]}>
          <Textfield
            placeholder={intl.formatMessage(
              messages.addressFormZipCodePlaceholder
            )}
            id="zipCode"
            name="zipCode"
            data-testid="zipCode"
            defaultValue={defaultValue}
            autoComplete="postal-code"
            outline
            required
            aria-describedby={
              getValidationError("zipCode")
                ? "instructions zipCode-error"
                : "instructions"
            }
          />
        </HeapPHIDecorator>
      </FormField>
    </>
  );
};

export { ZipCodeField };
